import Plotly from 'plotly.js/lib/core';
import Bar from "plotly.js/lib/bar.js";

// Load in the trace types for pie, and choropleth
Plotly.register([
  Bar
]);

export default Plotly;
